import React from 'react';

// chakra imports
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';
import Content from 'components/sidebar/components/Content';
import {
  renderThumb,
  renderTrack,
  renderView,
} from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import PropTypes from 'prop-types';

// Assets
import { IoMenuOutline } from 'react-icons/io5';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useContext } from 'react';
import { SidebarContext } from 'contexts/SidebarContext';

function Sidebar(props) {
  const { routes } = props;

  let variantChange = '0.2s linear';
  let shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.08)',
    'unset',
  );
  // Chakra Color Mode
  let sidebarBg = useColorModeValue('white', 'navy.800');
  let sidebarMargins = '0px';

  const { isCollapsed, toggleCollapse } = useContext(SidebarContext);

  // SIDEBAR
  return (
    <Box
      display={{ base: 'none', xl: 'block', md: 'block' }}
      position="fixed"
      minH="100%"
      zIndex="1000" // Ensure sidebar (and its hanging button) is above main content
    >
      <Box
        bg="transparent" // Let Content handle background
        transition={variantChange}
        w={isCollapsed ? '80px' : '290px'}
        h="100vh"
        m={sidebarMargins}
        minH="100%"
        overflowX="visible" // Allow button to hang out
        boxShadow="none" // Managed by content or parent
        position="relative"
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <Content routes={routes} collapse={isCollapsed} />
        </Scrollbars>

        {/* Toggle Button */}
        <Box position="absolute" right="-14px" top="15px" zIndex="100">
          <Box
            w="28px"
            h="28px"
            bg={useColorModeValue('teal.50', 'navy.700')}
            borderRadius="50%"
            boxShadow="0px 3px 8px rgba(0, 0, 0, 0.15)"
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            onClick={toggleCollapse}
            border="2px solid"
            borderColor={useColorModeValue('teal.50', 'navy.700')}
            color={useColorModeValue('teal.500', 'white')}
            _hover={{
              bg: useColorModeValue('teal.50', 'navy.600'),
              transform: 'scale(1.1)',
              transition: 'all 0.2s',
            }}
          >
            <Icon
              as={isCollapsed ? ChevronRightIcon : ChevronLeftIcon}
              w="16px"
              h="16px"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

// FUNCTIONS
export function SidebarResponsive(props) {
  let sidebarBackgroundColor = useColorModeValue('white', 'navy.800');
  let menuColor = useColorModeValue('gray.400', 'white');
  // // SIDEBAR
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const { routes } = props;
  // let isWindows = navigator.platform.startsWith("Win");
  //  BRAND

  return (
    <Flex display={{ base: 'flex', md: 'none' }} alignItems="center">
      <Flex ref={btnRef} w="max-content" h="max-content" onClick={onOpen}>
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my="auto"
          w="20px"
          h="20px"
          me="10px"
          _hover={{ cursor: 'pointer' }}
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === 'rtl' ? 'right' : 'left'}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent w="285px" maxW="285px" bg={sidebarBackgroundColor}>
          <DrawerCloseButton
            zIndex="3"
            onClose={onClose}
            _focus={{ boxShadow: 'none' }}
            _hover={{ boxShadow: 'none' }}
          />
          <DrawerBody maxW="285px" px="0rem" pb="0">
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <Content routes={routes} />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
// PROPS

Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
};

export default Sidebar;
